import type { ImageObject } from '../core/types'

export function buildSchemaImage(options: {
  id?: string
  url: string
  width?: number
  height?: number
  caption?: string
}): ImageObject {
  return {
    '@type': 'ImageObject',
    ...(options.id ? { '@id': options.id } : {}),
    url: options.url,
    contentUrl: options.url,
    ...(options.width ? { width: options.width } : {}),
    ...(options.height ? { height: options.height } : {}),
    ...(options.caption ? { caption: options.caption } : {})
  }
}
